import { CloseOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelectSync from '@nxsys/components/AppSelectSync';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';

type HolidayPaySummaryFilterModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onFilter: (params: HolidayPaySummaryFilterValues) => void;
  isBureau?: boolean;
};

export type HolidayPaySummaryFilterValues = {
  agency: Option<string> | null;
  company: Option<string> | null;
};

const HolidayPaySummaryFilterModal: React.FC<
  HolidayPaySummaryFilterModalProps
> = ({ isOpen, toggle, onFilter, isBureau }: HolidayPaySummaryFilterModalProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();
  const watchValue = Form.useWatch([], form);
  const ableToClearFilter =
    watchValue && Object.keys(watchValue).some((key) => !!watchValue[key]);

  const handleClearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    form.resetFields();
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    onFilter(values);
    toggle();
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.filter']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      closeIcon={
        <div style={{ marginRight: 90 }}>
          <AppButton
            name={messages['common.clearAll']}
            leftIcon={<CloseOutlined />}
            onClick={handleClearAll as any}
            disabled={!ableToClearFilter}
          />
        </div>
      }
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        {!isBureau && (
          <Form.Item label={messages['common.primaryAgency']} name="agency">
            <AppSelectSync
              type="agency"
              apiType="searchAgency"
              placeholder={messages['form.pleaseSelect']}
              onChangeValue={(value) => {
                form.setFieldsValue({
                  agency: value,
                });
              }}
            />
          </Form.Item>
        )}
        <Form.Item label={isBureau ? messages['common.employer'] : messages['common.paymentCompany']} name="company">
          <AppSelectSync
            type="company"
            apiType="searchCompany"
            placeholder={messages['form.pleaseSelect']}
            onChangeValue={(value) => {
              form.setFieldsValue({
                company: value,
              });
            }}
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default HolidayPaySummaryFilterModal;
